module.exports = __webpack_public_path__ + "img/bnb-icon.ce17a40c.svg";